
import { share } from 'rxjs/operators';
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, Subscription } from "rxjs";
import { HttpHeaders } from "@angular/common/http";
import { AppState } from "../../interfaces/app-state.interface";
import { Store } from "@ngrx/store";
import { HttpService } from "../http/http.service";
import { SettingsService } from '../settings/settings.service';
import { TokenType } from "../../enum/token-type.enum";
import { TokenCategory } from "../../enum/token-category.enum";
import { Token } from "../../models/authentication/token.model";

@Injectable()
export class BackendService {

    get headers(): HttpHeaders {
        if (this.authenticationToken) {
            return new HttpHeaders({
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': `Bearer ${this.authenticationToken}`,
            });
        }
        else {
            return new HttpHeaders({
                'Content-Type': 'application/json; charset=UTF-8',
                'X-SessionID': `${this.sessionIDUSer}`,
            });
        }
    }

    private authenticationToken: string;
    private authorizationToken: any;
    private sessionIDUSer: any;

    private autenticationDataSubscription$: Subscription;

    constructor(
        private store: Store<AppState>,
        private httpService: HttpService,
        private settings: SettingsService
    ) {

        this.store.select(s => s.authorization).subscribe(data => {
            this.authorizationToken = data ? data.token : {};
        });

        this.store.select(s => s.authentication).subscribe(data => {
            this.authenticationToken = data.currentUser ? data.currentUser.token : null;
            this.sessionIDUSer = data.sessionID ? data.sessionID : '';
        });
    }


    /** Realiza requisições HTTP GET ao resource server
     * @param url endereço HTTP a ser requisitado
     **/
    get<T>(url: string): Observable<T> {
        url = this.settings.baseUrl(url);
        return this.httpService.get<T>(url, this.headers).pipe(share());
    }

    /** Realiza requisições HTTP GET ao resource server esperando como resposta um blob
    * @param url endereço HTTP a ser requisitado
    **/
    getFile(url: string): Observable<any> {
        url = this.settings.baseUrl(url);
        return this.httpService.getFile(url, this.headers).pipe(share());
    }

    /** Realiza requisições HTTP POST  ao resource server
     * @param url endereço HTTP a ser requisitado
     * @param payload body da requisição,
     * @param token token de authorização
     **/
    post<T>(url: string, payload: any, token: Token = null, captcha: string = null, 
        captchaSiteKey: string = null, action: string = null, captchaType: string = null
    ): Observable<T> {
        url = this.settings.baseUrl(url);

        let headers = this.headers;
        if (token) {
            headers = headers.set('X-TOKEN', token.value);
            headers = headers.set('X-TOKEN_TYPE', token.type);
            headers = headers.set('X-TOKEN_CATEGORY', token.category);
        }
        if (captcha) {
            headers = headers.set('X-CAPTCHA', captcha);
            headers = headers.set('X-CLIENT', 'HUB');
            if(captchaSiteKey) headers = headers.set('x-CAPTCHA-SITEKEY', captchaSiteKey);
            if(captchaType) headers = headers.set('X-TYPE',captchaType ); 
            if(action) headers = headers.set('X-ACTION', action); 
        }

        if(payload && payload.captchaByPassToken){
            headers = headers.set('x-captcha-bypass-token', payload.captchaByPassToken); 
        }

        return this.httpService.post<T>(url, payload, headers).pipe(share());
    }


    /** Realiza requisições HTTP DELETE  ao resource server
     * @param url endereço HTTP a ser requisitado
     **/
    delete<T>(url: string, token: Token = null): Observable<T> {
        url = this.settings.baseUrl(url);

        let headers = this.headers;
        if (token) {
            headers = headers.set('X-TOKEN', token.value);
            headers = headers.set('X-TOKEN_TYPE', token.type);
            headers = headers.set('X-TOKEN_CATEGORY', token.category);
        }

        return this.httpService.delete<T>(url, headers).pipe(share());
    }

    /** Realiza requisições HTTP PUT ao resource server
     * @param url endereço HTTP a ser requisitado
     * @param payload body da requisição,
     **/
    put<T>(url: string, payload: any, token: Token = null): Observable<T> {
        url = this.settings.baseUrl(url);

        let headers = this.headers;
        if (token) {
            headers = headers.set('X-TOKEN', token.value);
            headers = headers.set('X-TOKEN_TYPE', token.type);
            headers = headers.set('X-TOKEN_CATEGORY', token.category);
        }

        return this.httpService.put<T>(url, payload, headers).pipe(share());
    }

    /** Realiza requisições HTTP PATCH ao resource server
     * @param url endereço HTTP a ser requisitado
     * @param payload body da requisição,
     **/
    patch<T>(url: string, payload: any, token: Token = null): Observable<T> {
        url = this.settings.baseUrl(url);
        let headers = this.headers;
        if (token) {
            headers = headers.set('X-TOKEN', token.value);
            headers = headers.set('X-TOKEN_TYPE', token.type);
            headers = headers.set('X-TOKEN_CATEGORY', token.category);
        }

        if (url.includes("v1.1/users") && this.sessionIDUSer) {
            headers = headers.set("X-SessionID", this.sessionIDUSer);
        }
        

        return this.httpService.patch<T>(url, payload, headers).pipe(share());
    }
}
